import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	TELEGRAM_BOT: `${RouteNames.CHAT_GATEWAYS}-telegram-bot`,
	TELEGRAM_APP: `${RouteNames.CHAT_GATEWAYS}-telegram-app`,
	INFOBIP: `${RouteNames.CHAT_GATEWAYS}-infobip`,
	META: `${RouteNames.CHAT_GATEWAYS}-meta`,
	VIBER: `${RouteNames.CHAT_GATEWAYS}-viber`,
	WEBCHAT: `${RouteNames.CHAT_GATEWAYS}-webchat`,
	CUSTOM: `${RouteNames.CHAT_GATEWAYS}-custom`,
	TEMPLATES: `${RouteNames.CHAT_GATEWAYS}-templates`,
	VIEW: `${RouteNames.CHAT_GATEWAYS}-view`,
	CHAT: `${RouteNames.CHAT_GATEWAYS}-chat`,
	APPOINTMENT: `${RouteNames.CHAT_GATEWAYS}-appointment`,
	ALTERNATIVE_CHANNELS: `${RouteNames.CHAT_GATEWAYS}-alternative-channels`,
	RE_CAPTCHA: `${RouteNames.CHAT_GATEWAYS}-re-captcha`,
	FACEBOOK_PAGES: `${RouteNames.CHAT_GATEWAYS}-facebook-pages`,
	INSTAGRAM: `${RouteNames.CHAT_GATEWAYS}-instagram`,
	WHATSAPP: `${RouteNames.CHAT_GATEWAYS}-whatsapp`,
	STYLE: `${RouteNames.CHAT_GATEWAYS}-style`,
});
